export default "__VITE_ASSET__BBSBPNds__"